import * as React from "react"

export default function ExperienceBeginnerIcon(props) {
  return (
    <svg
      width={32}
      height={32}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9 16C9.55228 16 10 16.4477 10 17V28C10 28.5523 9.55228 29 9 29H3C2.44772 29 2 28.5523 2 28V17C2 16.4477 2.44772 16 3 16H9Z"
        fill={props.fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19 11C19.5523 11 20 11.4477 20 12V28C20 28.5523 19.5523 29 19 29H13C12.4477 29 12 28.5523 12 28V12C12 11.4477 12.4477 11 13 11H19ZM14 27H18V13H14V27Z"
        fill={props.fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M29 3C29.5523 3 30 3.44772 30 4V28C30 28.5523 29.5523 29 29 29H23C22.4477 29 22 28.5523 22 28V4C22 3.44772 22.4477 3 23 3H29ZM24 27H28V5H24V27Z"
        fill={props.fill}
      />
    </svg>
  )
}
